export { type MenuTab2Item, MenuTabs2 } from "./MenuTabs2";
